import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { useAuthStore } from '@/stores/auth-store';

// Pages
import { LandingPage } from '@/pages/landing';
import { WelcomePage } from '@/pages/welcome';
import { OnboardingPage } from '@/pages/onboarding';
import { HomePage } from '@/pages/home';
import { SearchPage } from '@/pages/search';
import { ListingPage } from '@/pages/listing';
import { EventPage } from '@/pages/event';
import { ChatPage } from '@/pages/chat';
import { ProfilePage } from '@/pages/profile';
import { NotFoundPage } from '@/pages/not-found';

// Layouts
import { MainLayout } from '@/components/layouts/main-layout';
import { AuthLayout } from '@/components/layouts/auth-layout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuthStore();
  
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/bem-vindo" replace />;
  }
  
  if (!user.onboarding.completed) {
    return <Navigate to="/cadastro" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <>
      <Routes>
        {/* Landing page - public */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Auth routes */}
        <Route element={<AuthLayout />}>
          <Route path="/bem-vindo" element={<WelcomePage />} />
          <Route path="/cadastro" element={<OnboardingPage />} />
        </Route>
        
        {/* App routes - protected */}
        <Route element={<MainLayout />}>
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/buscar"
            element={
              <ProtectedRoute>
                <SearchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/cozinhar"
            element={
              <ProtectedRoute>
                <ListingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/evento/:id"
            element={
              <ProtectedRoute>
                <EventPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/chat/:id"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/perfil"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
        </Route>
        
        {/* Catch all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      
      <Toaster />
    </>
  );
}

export default App;

